import React, { useMemo } from "react";
import PropTypes from "prop-types";
import styles from "./EventCard.module.css";
import getTime from "../utils/getTime";

import DocumentItem from "Security/Shared/DocumentItem";
import PDFIcon from "../../assets/file-light.svg";
import { ReactComponent as AlarmIcon } from "../../assets/alarm-exclamation-light.svg";

/**
 * View component.
 * Displays information about an event in a card.
 */
export function EventCard({ eventInfo }) {
  // Does not update until page refresh.
  const daysLeft = useMemo(() => {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    const eventDate = new Date(eventInfo.date);

    let retDate = Math.round(
      (eventDate.getTime() - currentDate.getTime()) / (1000 * 3600 * 24)
    );

    // Check the event time if current date to see if start time has passed
    if (
      retDate === 0 &&
      new RegExp("\\b\\d{2}:\\d{2} (AM|PM)\\b").test(eventInfo.time)
    ) {
      const newDate = new Date();
      // Uses local time
      // TODO: Change accordingly for API
      const currentHour = newDate.getHours();
      const currentMinute = newDate.getUTCMinutes();
      const eventTime = getTime(eventInfo.time).map((number) => Number(number));

      if (
        currentHour < eventTime[0] ||
        (currentHour === eventTime[0] && currentMinute <= eventTime[1])
      ) {
        return 0;
      }
      return -1;
    }

    return retDate;
  }, [eventInfo]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>{eventInfo.name}</div>
        <div className={styles.timer}>
          <AlarmIcon />
          {isNaN(daysLeft)
            ? "Unknown"
            : daysLeft < 0
            ? "Ended"
            : daysLeft === 0
            ? "Today"
            : `${daysLeft} day${daysLeft !== 1 ? "s" : ""}`}
        </div>
      </div>
      <div className={styles["date-container"]}>
        <div>{eventInfo.location}</div>
        <div>{eventInfo.date}</div>
        <div>{eventInfo.time}</div>
      </div>
      <div className={styles.notes}>{eventInfo.notes}</div>
      <div className={styles.file}>
        <DocumentItem
          icon={PDFIcon}
          description="Document"
          onClick={() => alert("clicked")}
        />
      </div>
    </div>
  );
}

EventCard.propTypes = {
  /**
   * Object with the event's info.
   */
  eventInfo: PropTypes.shape({
    name: PropTypes.string,
    location: PropTypes.string,
    date: PropTypes.string,
    time: PropTypes.string,
    notes: PropTypes.string,
    src: PropTypes.string,
  }),
};
